import { render, staticRenderFns } from "./aiRealProject.vue?vue&type=template&id=80c00214&scoped=true"
import script from "./aiRealProject.vue?vue&type=script&lang=js"
export * from "./aiRealProject.vue?vue&type=script&lang=js"
import style0 from "./aiRealProject.vue?vue&type=style&index=0&id=80c00214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c00214",
  null
  
)

export default component.exports